import Button from "@mui/material/Button";

const Disconnect = () => {
	return (
		<div>
			<Button variant="outlined" color="warning">
				Disconnect
			</Button>
		</div>
	);
};

export default Disconnect;
